<template>
  <div>
    <div style="padding: 10px; min-height: 100px">
      <x-table
        listApi="biz.customer.supplier.info.list"
        paginationLayout="total, sizes, prev, next, jumper"
        defaultSort="opt_status asc"
        actionFixed="right"
        emptyLabel="暂无供货单位信息"
        :btnList="btnList"
        :defaultParams="defaultParams"
        :fieldList="fieldList"
        :actionList="actionList"
        :actionWidth="120"
      >
        <template slot="row-info" slot-scope="scope">
          <div style="font-weight: bolder">
            {{ scope.row.name }}
          </div>
          <div style="color: #676767">编号：{{ scope.row.guid }}</div>
          <div style="color: #676767">
            <span v-if="scope.row.optDefault == 1" style="color: #3399ff">
              默认
              <span style="color: #919191"> | </span>
            </span>
            <span v-if="scope.row.optVet == 1" style="color: #ff0000">
              兽药
              <span style="color: #919191"> | </span>
            </span>
            <span v-if="scope.row.companyName">
              {{ scope.row.companyName }}
            </span>
            <span v-else style="color: #919191"> 未完善供货单位公司信息 </span>
          </div>
        </template>
      </x-table>
    </div>
  </div>
</template>

<script>
import formPage from "./__store_supplier_form.vue";
import customerStoreSelect from "../../../../components/business/customerStoreSelect.vue";

export default {
  components: {
    customerStoreSelect,
  },
  props: {
    params: {
      type: Object,
      default: () => ({}),
    },
    query: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    defaultParams() {
      return Object.assign({}, this.queryModel || {});
    },
    pageParams() {
      return Object.assign({}, (this.$route && this.$route.params) || {}, this.params);
    },
    pageQuery() {
      return Object.assign({}, (this.$route && this.$route.query) || {}, this.query);
    },
  },
  methods: {
    clearClick() {
      this.formInline = {
        queryValue: "",
      };
      this.queryModel = {};
    },
    queryClick() {
      this.queryModel = Object.assign({}, this.formInline);
    },
  },
  data() {
    return {
      queryModel: {},
      formInline: {
        nameLike: "",
      },
      fieldList: [
        {
          label: "供货单位信息",
          minWidth: "240",
          slot: "info",
        },
        {
          label: "兽药资质",
          width: "120",
          render: (row) => (row.optVet == 1 ? "通过" : "X"),
        },
      ],
      actionList: [
        {
          label: "编辑",
          show: (row) => {
            if (!this.$hasPower(["optSuper", "biz.customer.supplier.info.update"])) {
              return false;
            }
            return true;
          },
          click: (row, tag, refresh) => {
            this.$drawer.openDrawer({
              title: "编辑供货单位信息",
              refresh,
              component: formPage,
              params: {
                guid: row.guid,
              },
            });
          },
        },
        {
          label: "删除",
          linkType: "danger",
          show: (row) => {
            if (!this.$hasPower(["optSuper", "biz.customer.supplier.info.delete"])) {
              return false;
            }
            return true;
          },
          click: (row, tag, refresh) => {
            this.$confirm(
              `确定删除，此操作不可恢复，请谨慎操作?`,
              "提示",
              {
                type: "warning",
              },
              {
                showError: true,
              }
            ).then(() => {
              this.requestApi(
                "biz.customer.supplier.info.delete",
                {
                  guid: row.guid,
                },
                {
                  showError: true,
                }
              ).then(() => {
                this.success("保存成功");
                this.$drawer.refreshDrawer();
                refresh && refresh();
              });
            });
          },
        },
      ],
      btnList: [
        {
          label: "新增供货单位",
          type: "primary",
          show: (row) => {
            if (!this.$hasPower(["optSuper", "biz.customer.supplier.info.create"])) {
              return false;
            }
            return true;
          },
          click: (row, tag, refresh) => {
            this.$drawer.openDrawer({
              title: "新增供货单位",
              refresh,
              component: formPage,
              params: this.defaultParams,
            });
          },
        },
      ],
    };
  },
  mounted() {},
};
</script>
